export default __webpack_public_path__ + "static/media/Afacad-SemiBold.33b87ce9.ttf";